import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { NotificationStatus } from '../../../types/notifications'
import { getUrlWithVersion } from '../../../api/api'

export const markFilteredNotificationsRead = createAsyncThunk<
    void,
    { productIDs: string[] },
    ThunkConfig<string>
>(
    'notificationsSlice/markFilteredNotificationsRead',
    async (args, thunkAPI) => {
        const {
            extra: { api },
            rejectWithValue,
        } = thunkAPI

        const { productIDs } = args

        try {
            await api.put(getUrlWithVersion(`/notifications/status`), {
                product_ids: productIDs,
                status: NotificationStatus.READ,
            })
        } catch (e) {
            alertErrorMessage(e)
            return rejectWithValue('Failed to mark notifications read')
        }
    }
)
